<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form-model :model="formData" :rules="rules" ref="ruleForm">
                <a-form-model-item label="Kegiatan" prop="title">
                    <a-input v-model="formData.title"/>
                </a-form-model-item>

                <a-form-model-item label="Tanggal Perencanaan Mulai" prop="plan_date_start">
                    <a-date-picker
                        @change="onStartDateChange"
                        :format="'YYYY-MM-DD'"
                        v-model="formData.plan_date_start"
                        type="date"
                    />
                </a-form-model-item>

                <a-form-model-item label="Tanggal Perencanaan Selesai" prop="plan_date_end">
                    <a-date-picker
                        @change="onTargetDateChange"
                        :format="'YYYY-MM-DD'"
                        v-model="formData.plan_date_end"
                        type="date"
                    />
                </a-form-model-item>

                <a-form-model-item label="Selesai Pelaksanaan">
                    <a-date-picker
                        @change="onActualDateChange"
                        :format="'YYYY-MM-DD'"
                        v-model="formData.actual_date_end"
                        type="date"
                    />
                </a-form-model-item>

                <a-row type="flex" :gutter="8">
                    <a-col :span="12">
                        <a-form-model-item label="Status">
                            <a-select v-model="formData.status" @change="statusChange">
                                <a-select-option
                                    key='not'
                                    value="not_done">
                                    Not Done
                                </a-select-option>
                                <a-select-option
                                    key='progress'
                                    value="progress">
                                    Progress
                                </a-select-option>
                                <a-select-option
                                    key='done'
                                    value="done">
                                    Done
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="Progress (%)">
                            <a-input-number v-model="formData.progress" :min="0" :max="formData.status == 'progress' ? 99 : 100" :disabled="!disable"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-form-model-item label="PIC">
                    <a-input v-model="formData.pic"/>
                </a-form-model-item>

                <a-form-model-item label="Issue">
                    <a-textarea v-model="formData.issue" :rows="4" />
                </a-form-model-item>

                <a-form-model-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="handleSubmit"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-model-item>
            </a-form-model>
        </a-skeleton>
    </a-card>
</template>

<script>
import moment from 'moment'

export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        items: {
            type: Object
        },
        hash: {
            type: String,
            default: ''
        },
        edit: {
            type: Boolean,
            default: false
        },
        activity: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            readOnly: true,
            item: {},
            formData: {
                status: 'not_done',
                progress: 0
            },
            rules: {
                title: [{ required: true, message: 'Judul harus diisi', trigger: 'blur' }],
                plan_date_start: [{ required: true, message: 'Tanggal mulai perencanaan harus diisi', trigger: 'change' }],
                plan_date_end: [{ required: true, message: 'Tanggal berakhir perencanaan harus diisi', trigger: 'change' }],
            }
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
        }
    },
    computed: {
        editing() {
            return this.hash !== ""
        },
        disable(){
            return this.formData.status == "progress"
        },
        progressDone() {
            return this.formData.status == "done"
        }
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri('api.project-management.action-step.show', {
                        detail_step: this.hash
                    })
                )
                .then(res => (this.formData = res.data))
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.$refs.ruleForm.validate(valid => {
                if(valid){
                    this.processing = true

                    let promise

                    this.formData.charter_id = this.items.id
                    this.formData.activity_id = this.activity

                    if (this.editing) {
                        this.formData.actual_date_end = moment(this.formData.actual_date_end).format('YYYY-MM-DD')

                        promise = this.$http.put(
                            this.routeUri('api.project-management.action-step.update', {
                                detail_step: this.hash
                            }),
                            this.formData
                        );
                    } else {
                        promise = this.$http.post(
                            this.routeUri('api.project-management.action-step.store'),
                            this.formData
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false))
                }else{
                    return false
                }
            })
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
        onStartDateChange(date, dateString) {
            this.formData.plan_date_start = dateString
        },
        onTargetDateChange(date, dateString) {
            this.formData.plan_date_end = dateString
            
            if(!this.editing)
                this.formData.actual_date_end = dateString

        },
        onActualDateChange(date, dateString) {
            this.formData.actual_date_end = dateString
        },
        statusChange(value) {
            console.log(`selected ${value}`);
            switch(value){
                case 'progress':
                    if(this.formData.progress == 100){
                        this.formData.progress = 99
                    }
                    break
                case 'done':
                    this.formData.progress = 100
                    break
                default:
                    this.formData.progress = 0

            }
            if(value == 'not_done')
                this.formData.progress = 0

            
        },

    },
}
</script>
